 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"auth":"auth","login":"login","Reset":"Reset","Register":"Register","home":"home","invoices":"invoices","notifications":"notifications","notifications/create":"notifications/create","orders":"orders","payments":"payments","roles":"roles","roles/create":"roles/create","roles/edit":"roles/edit","users":"users","default":"default","profile":"profile","email-confirmed":"email-confirmed","help":"help","error403":"error403","error404":"error404","error500":"error500","orders/edit":"orders/edit","Dashboard":"Dashboard"}[chunkId]||chunkId) + "." + {"auth":"aa831a58","chunk-5725aac0":"4413112c","chunk-3ba08120":"e66dd4c1","login":"10d7ef5e","chunk-d9673a10":"6f072ea2","Reset":"5e3eb505","chunk-383898fc":"b017fdff","Register":"4b1408c4","home":"06470e1e","invoices":"42315b75","notifications":"e5099a90","notifications/create":"1bb15a80","orders":"8c1359e8","payments":"26e7c234","roles":"f55af0e1","roles/create":"f1a3dd3a","roles/edit":"3a98af54","users":"477ccf3c","chunk-9e7fc328":"9dfe0ff2","default":"bf0db318","profile":"5265087f","email-confirmed":"e40d1a2d","chunk-c8c574b2":"ecf0c152","help":"c74f0250","error403":"7d67878a","error404":"b151fc1e","error500":"97e9454e","orders/edit":"e6093831","chunk-fbdd2a2e":"d0329e19","chunk-0eea7285":"56d0d256","chunk-1e31fa48":"5e0ccbab","chunk-1e6a28eb":"09787253","chunk-b9bb3072":"e10e0320","chunk-352dd891":"93b8d8c1","chunk-adbfa8be":"9118d0ee","chunk-2d0db439":"a47f6e3d","Dashboard":"a5fc2369","chunk-03907fd1":"fdb3799e","chunk-096a9684":"424039b3","chunk-1f2f4ec3":"4a7ac081","chunk-3f0f8a78":"2b7d98fc","chunk-4227c652":"dba52104"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"auth":1,"chunk-5725aac0":1,"chunk-3ba08120":1,"login":1,"chunk-d9673a10":1,"Reset":1,"chunk-383898fc":1,"Register":1,"home":1,"invoices":1,"notifications":1,"notifications/create":1,"orders":1,"payments":1,"roles":1,"roles/create":1,"roles/edit":1,"users":1,"chunk-9e7fc328":1,"default":1,"profile":1,"email-confirmed":1,"chunk-c8c574b2":1,"help":1,"error403":1,"error404":1,"error500":1,"orders/edit":1,"chunk-fbdd2a2e":1,"chunk-0eea7285":1,"chunk-1e31fa48":1,"chunk-1e6a28eb":1,"chunk-b9bb3072":1,"chunk-352dd891":1,"chunk-adbfa8be":1,"Dashboard":1,"chunk-03907fd1":1,"chunk-096a9684":1,"chunk-1f2f4ec3":1,"chunk-3f0f8a78":1,"chunk-4227c652":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"auth":"auth","login":"login","Reset":"Reset","Register":"Register","home":"home","invoices":"invoices","notifications":"notifications","notifications/create":"notifications/create","orders":"orders","payments":"payments","roles":"roles","roles/create":"roles/create","roles/edit":"roles/edit","users":"users","default":"default","profile":"profile","email-confirmed":"email-confirmed","help":"help","error403":"error403","error404":"error404","error500":"error500","orders/edit":"orders/edit","Dashboard":"Dashboard"}[chunkId]||chunkId) + "." + {"auth":"20f3a56a","chunk-5725aac0":"32490ca0","chunk-3ba08120":"79eff430","login":"af1fa4eb","chunk-d9673a10":"41b6f088","Reset":"4c4fa3a9","chunk-383898fc":"cd26591f","Register":"07ba3884","home":"d7bace80","invoices":"3c783520","notifications":"fdf5ef07","notifications/create":"6c35acff","orders":"3e651c5b","payments":"fb66cf49","roles":"cb11b7be","roles/create":"4c5a0c3d","roles/edit":"8138c423","users":"839b05e8","chunk-9e7fc328":"50f1ffb9","default":"47417811","profile":"e92f65c6","email-confirmed":"6186599d","chunk-c8c574b2":"b1aa019a","help":"c163151a","error403":"a3368e2b","error404":"08c01adc","error500":"354b0772","orders/edit":"3f596aec","chunk-fbdd2a2e":"1380c8a1","chunk-0eea7285":"10874ebd","chunk-1e31fa48":"4c03518d","chunk-1e6a28eb":"850df92a","chunk-b9bb3072":"d6a01c08","chunk-352dd891":"b552fbe9","chunk-adbfa8be":"cf6546c5","chunk-2d0db439":"31d6cfe0","Dashboard":"a3055ac0","chunk-03907fd1":"cd8a6871","chunk-096a9684":"86160ed1","chunk-1f2f4ec3":"78ba4047","chunk-3f0f8a78":"95646f49","chunk-4227c652":"d8c5f490"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
